import { render, staticRenderFns } from "./NearByFoods.vue?vue&type=template&id=4d88a68c&"
import script from "./NearByFoods.vue?vue&type=script&lang=js&"
export * from "./NearByFoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports